import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import PreviewVendorApproval from "./PreviewVendorApproval";

const VendorApprovalCreation = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [step, setStep] = useState(1);
  const [sra, setSra] = useState();
  const [fileNames, setFileNames] = useState({
    attachment1Filename: "",
    attachment2Filename: "",
    attachment3Filename: "",
    attachment4Filename: "",
    attachment5Filename: "",
  });
  const [fetching, setFetching] = useState(false);
  const { draftSraId } = useParams();
  const location = useLocation();
  const [noOfApprovers, setNoOfApprovers] = useState();
  const [approvers, setApprovers] = useState({
    approver1: "",
    approver2: "",
    approver3: "",
    approver4: "",
  });
  const isClone = location.state?.clone;
  const cloneData = location.state?.data;

  useEffect(() => {
    if (isClone && cloneData) {
      const getSRA = async () => {
        setFetching(true);
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/vendor-approval/by-id?sraId=${cloneData.id}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setSra({
            title: res.data.title || "",
            vendorCode: res.data.vendorCode || "",
            companyName: res.data.companyName || "",
            address: res.data.address || "",
            poc: res.data.poc || "",
            structure: res.data.structure || "",
            gst: res.data.gst || "",
            msme: res.data.msme || "",
            need: res.data.need || "",
            currentStatus: res.data.currentStatus || "",
            info: res.data.info || "",
            reference: res.data.reference || "",
            attachment1: res.data.attachment1 || "",
            attachment2: res.data.attachment2 || "",
            attachment3: res.data.attachment3 || "",
            attachment4: res.data.attachment4 || "",
            attachment5: res.data.attachment5 || "",
          });
          setFileNames({
            ...fileNames,
            attachment1Filename: res.data.attachment1Filename || "",
            attachment2Filename: res.data.attachment2Filename || "",
            attachment3Filename: res.data.attachment3Filename || "",
            attachment4Filename: res.data.attachment4Filename || "",
            attachment5Filename: res.data.attachment5Filename || "",
          });
        } catch (error) {
          console.log(error);
        } finally {
          setFetching(false);
        }
      };
      getSRA();
    }
  }, [isClone, cloneData]);

  const getDraft = async () => {
    setFetching(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft-vendor-approval?draftSraId=${draftSraId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
      setSra(res.data);
      setNoOfApprovers(res.data.numberOfApprovers);
      setFileNames({
        ...fileNames,
        attachment1Filename: res.data.attachment1Filename || "",
        attachment2Filename: res.data.attachment2Filename || "",
        attachment3Filename: res.data.attachment3Filename || "",
        attachment4Filename: res.data.attachment4Filename || "",
        attachment5Filename: res.data.attachment5Filename || "",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    if (draftSraId !== undefined) {
      getDraft();
    }
  }, [location]);

  return (
    <div style={{ position: "relative" }}>
      {fetching && <div className="loading-div"></div>}
      {step === 1 && (
        <Step1
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          fileNames={fileNames}
          setFileNames={setFileNames}
          storedUser={storedUser}
        />
      )}
      {step === 2 && (
        <Step2
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}
      {step === 3 && (
        <Step3
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          setFileNames={setFileNames}
        />
      )}
      {step === 4 && (
        <Step4
          sra={sra}
          setSra={setSra}
          approvers={approvers}
          setApprovers={setApprovers}
          noOfApprovers={noOfApprovers}
          setNoOfApprovers={setNoOfApprovers}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}

      {step === 5 && (
        <PreviewVendorApproval
          sra={sra}
          approvers={approvers}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          noOfApprovers={noOfApprovers}
        />
      )}
    </div>
  );
};

export default VendorApprovalCreation;
